import axios from 'axios'

export const api = axios.create({
  // api laravel
  baseURL: 'https://api.brasilagritest.com/api/',
  // baseURL: 'http://127.0.0.1:8000/api/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export const apiIot = axios.create({
  // api iot
  baseURL: 'http://127.0.0.1:5000/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export const behavior = (method, urn, body, onSuccess, onFailure) => {
  // Map Request Methods
  const verbs = {
    postIot: apiIot.post,
    getIot: apiIot.get,
    deleteIot: apiIot.delete,
    post: api.post,
    put: api.put,
    get: api.get,
    delete: api.delete
  }

  // Configure Request Call
  const call = body
    ? verbs[method](urn, body) // Create, Update
    : verbs[method](urn) // Read

  // Send Request to Api
  call.then(response => {
    if ([200, 201, 204].includes(response.status)) {
      onSuccess(response)
    }
  }, error => {
    onFailure(error.message + (error.response.status === 422 ? ' => ' + error.response.data.errors : ''))
    return Promise.reject(error)
  })
}

// Map methods for ease function calls
export const request = {
  postIot: (urn, body, onSuccess, onFailure) => behavior('postIot', urn, body, onSuccess, onFailure),
  getIot: (urn, onSuccess, onFailure) => behavior('getIot', urn, null, onSuccess, onFailure),
  deleteIot: (urn, onSuccess, onFailure) => behavior('deleteIot', urn, null, onSuccess, onFailure),
  post: (urn, body, onSuccess, onFailure) => behavior('post', urn, body, onSuccess, onFailure),
  put: (urn, body, onSuccess, onFailure) => behavior('put', urn, body, onSuccess, onFailure),
  get: (urn, onSuccess, onFailure) => behavior('get', urn, null, onSuccess, onFailure),
  delete: (urn, onSuccess, onFailure) => behavior('delete', urn, null, onSuccess, onFailure)
}
